import { Component, OnInit, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { LookupService } from 'src/app/core/services/lookup.service';
import { CookieService } from 'ngx-cookie-service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AgencyService } from 'src/app/core/services/agency.service';
import { localStorageConstants, localStorageVariables } from 'src/app/core/localStorageConstants/localStorageConstants';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';

import {
  UntypedFormControl
} from '@angular/forms';
import { UserProfileService } from 'src/app/core/services/user-profile.service';
import { LoginService } from 'src/app/core/services/login.service';
import { InteractorService } from 'src/app/core/services/interactor.service';
@Component({
  // selector: 'app-superadmin-home',
  templateUrl: './superadmin-home.component.html',
  styleUrls: ['./superadmin-home.component.scss']
})
export class SuperadminHomeComponent implements OnInit {
  @Output() modalEvent = new EventEmitter<boolean>();
  @ViewChild('template') elementView: TemplateRef<any>;
  public agencyFilterCtrl: UntypedFormControl = new UntypedFormControl();
  public originalAgencies = [];
  toastErrorBgColor: any;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  formChange = this.brandingDetails?.branding?.BackgroundColors?.FormChangePassword;
  formBox = this.brandingDetails?.branding?.BackgroundColors?.FormBoxShadow;
  headerLogin = this.brandingDetails?.branding?.BackgroundColors?.HeaderLogin;
  pwdBtn = this.brandingDetails?.branding?.BackgroundColors?.PwdBtn;
  toastSuccessBgColor: any;
  toastErrorFontColor: any;
  toastSuccessFontColor: any;
  headerColor: any;
  notification1: any;
  notification2: any;
  dashboardBorder: any;
  cancelButtonHover: any;
  cancelButton: any;
  button1: any;
  button2: any;
  buttonHover: any;
  buttonFont: any;
  alternateRowsLight: any;
  alternateRowsDark: any;
  headerBackground: any;
  tableHeadColor: any;
  disabledHeaderBackground: any;
  editButtonBackground: any;
  editButtonHoverBackground: any;
  activateBtn: any;
  buttonFontColor: any;
  EditBtn: any;
  EditBtnHover: any;
  redBtn: any;
  blueBtn: any;
  greenBtn: any;
  confirmDeleteBtn: any;
  confirmDeleteBtnHover: any;
  confirmCancelBtn: any;
  gridBorderColor: any;
  selectPersonStatus: any;
  matTealDark: any;
  matError: any;
  matWhite: any;
  matOrange: any;
  matGreenYellow: any;
  matGreyGreen: any;
  matLightGreen: any;
  matBlack: any;
  matRussianBlack: any;
  matInputGrey: any;
  matCheckBoxBg: any;
  checkedCheckBoxBg: any;
  matTealLight: any;
  calenderNotSelectedBg: any;
  datePickerContent: any;
  checkBoxDisabledBg: any;
  headerFontColor: any;
  breadcrumbBg: any;
  tableFontColor: any;
  greyLightBg: any;
  tabBody: any;
  cardFontColor: any;
  linkButtons: any;
  dropdownBorderColor: any;
  btnLightBlue: any;
  questionnaireSubHeader: any;
  activeTabColor: any;
  disabledQuestionnaireHeader: any;
  subTabBgColor: any;
  cardCancelButton: any;
  activeAdminTabFontColor: any;


  constructor(
    public lookupService: LookupService,
    public cookieService: CookieService,
    private localStorageService: LocalStorageService,
    private modalRef: BsModalRef,
    private agencyService: AgencyService,
    private translatorService: TranslateService,
    private profileService: UserProfileService,
    private loginService: LoginService,
    private interactorService: InteractorService,


  ) {
    this.translatorService.setDefaultLang('en');
    this.translatorService.use(localStorage.getItem('lang') || 'en');
  }

  public error: boolean;
  public message: string;
  public agencies = [];
  public selectedAgency;
  public isDefault = false;

  ngOnInit(): void {
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--formChange', this.brandingDetails?.branding?.BackgroundColors?.FormChangePassword);
        document.documentElement.style.setProperty('--formBox', this.brandingDetails?.branding?.BackgroundColors?.FormBoxShadow);
        document.documentElement.style.setProperty('--headerLogin', this.brandingDetails?.branding?.BackgroundColors?.HeaderLogin);
        document.documentElement.style.setProperty('--pwdBtn', this.brandingDetails?.branding?.BackgroundColors?.PwdBtn);
      }
      this.setBackgroundColors();
    });
    document.documentElement.style.setProperty('--formChange', this.brandingDetails?.branding?.BackgroundColors?.FormChangePassword);
    document.documentElement.style.setProperty('--formBox', this.brandingDetails?.branding?.BackgroundColors?.FormBoxShadow);
    document.documentElement.style.setProperty('--headerLogin', this.brandingDetails?.branding?.BackgroundColors?.HeaderLogin);
    document.documentElement.style.setProperty('--pwdBtn', this.brandingDetails?.branding?.BackgroundColors?.PwdBtn);
    this.getAgencies();
    this.autocompleteChanges();
  }
  /**
     * Function to trigger on auto-complete keypress
     */
  public autocompleteChanges() { // tslint:disable-next-line: deprecation
    this.agencyFilterCtrl.valueChanges.subscribe(value => {
      if (value) {
        this.agencies = this.lookupService.filterForAutoComplete(this.originalAgencies, value, 'name');
      } else {
        this.agencies = [...this.originalAgencies];
      }
    });
  }
  getAgencies() {

    // tslint:disable-next-line: deprecation
    this.lookupService.getAllAgencies().subscribe(res => {
      if (res.StatusCode !== 200) {
        this.error = true;
        this.message = res.Message;
      } else {

        this.agencies = res.Data.agencyLookup;
        this.originalAgencies = res.Data.agencyLookup;
        this.selectedAgency = parseInt(this.localStorageService.getDataFromLocalStorage(localStorageVariables.agencyId));
        this.setDefault(this.selectedAgency, '');
      }
    }, err => {
      this.error = true;
      this.message = err.Message;
    });
  }

  go() {
    this.modalRef.hide();
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.collaborationLevels);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.helperTitle);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.identificationTypes);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.languages);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.notificationLevel);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.raceEthnicity);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.sexuality);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.gender);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.supportType);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.collaborationTypes);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.identifiedGender);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.collaborationTagType);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.collaborationLeads);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.countryStates);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.category);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.roles);
    this.localStorageService.deleteLocalStorageByKey(localStorageConstants.notificationType);

    const selectedAgency = this.agencies?.filter(a => a.agencyID === this.selectedAgency);
    this.profileService.agencyName = selectedAgency[0]?.name;
    const userId = Number(this.localStorageService.getDataFromLocalStorage(localStorageVariables.UserId));
    let languages = JSON.parse(localStorage.getItem('languageList'))?.result?.agencyLanguage;
    let currentLanguage = languages.find((x) => x.agencyLanguageID == selectedAgency[0]?.agencyLanguageId);
    sessionStorage.setItem('lang', currentLanguage != undefined ? currentLanguage?.attribute : 'en');
    sessionStorage.setItem('agencyLanguageId', selectedAgency[0]?.agencyLanguageId);
    this.lookupService.getBrandingDetails().subscribe(
      (res) => {
        if (res.StatusCode !== 200) {
          this.error = true;
          this.message = res.Message;
        } else {
          this.brandingDetails = res.Data;
          this.interactorService.changeBrandingDetails(this.brandingDetails);
          this.headerColor = this.brandingDetails?.branding.BackgroundColors.Headers;
          document.documentElement.style.setProperty('--headerColor', this.headerColor);
          this.setBackgroundColors();
          this.setFontColors();
          this.setMatColors();
        }
      },
      (err) => {
        this.error = true;
        this.message = err.Message;
      }
    );

    if (this.isDefault) {
      this.agencyService.setDefaultAgency({
        userID: userId,
        agencyID: selectedAgency[0].agencyID // tslint:disable-next-line: deprecation
      }).subscribe(
        (response) => {

          if (response.StatusCode.toString() === '200') {
            this.localStorageService.saveInLocalStorage(localStorageVariables.defaultAgency, selectedAgency[0].agencyID);
            this.localStorageService.saveInLocalStorage(localStorageVariables.setDefaultAgency, 'true');
            this.localStorageService.saveInLocalStorage(localStorageVariables.tenantAbbreviation, selectedAgency[0].abbrev);
            this.localStorageService.saveInLocalStorage(localStorageVariables.agencyId, selectedAgency[0].agencyID);
            this.localStorageService.saveInLocalStorage(localStorageVariables.agencyName, selectedAgency[0].name);
            // Clear needs and strengths metrics on agency switch
            localStorage.removeItem('needssMetrics');
            localStorage.removeItem('strengthsMetrics');
            window.location.href = 'dashboard';
          }
        });
    } else {
      this.localStorageService.saveInLocalStorage(localStorageVariables.setDefaultAgency, 'true');
      this.localStorageService.saveInLocalStorage(localStorageVariables.tenantAbbreviation, selectedAgency[0].abbrev);
      this.localStorageService.saveInLocalStorage(localStorageVariables.agencyId, selectedAgency[0].agencyID);
      this.localStorageService.saveInLocalStorage(localStorageVariables.agencyName, selectedAgency[0].name);
      this.localStorageService.saveInLocalStorage(localStorageVariables.Tenant, selectedAgency[0].agencyID);
      // Clear needs and strengths metrics on agency switch
      localStorage.removeItem('needssMetrics');
      localStorage.removeItem('strengthsMetrics');
      window.location.href = 'dashboard';
    }

  }

  setBackgroundColors() {
    this.toastErrorBgColor = this.brandingDetails?.branding?.AlertColors?.ErrorAlertColor;
    this.toastSuccessBgColor = this.brandingDetails?.branding?.AlertColors?.SuccessAlertColor;
    this.notification1 = this.brandingDetails?.branding.BackgroundColors?.Notification1;
    this.notification2 = this.brandingDetails?.branding.BackgroundColors?.Notification2;
    this.cancelButton = this.brandingDetails?.branding.BackgroundColors?.CancelBtnAddPerson;
    this.cancelButtonHover = this.brandingDetails?.branding.BackgroundColors?.CancelBtnAddPersonHover;
    this.dashboardBorder = this.brandingDetails?.branding.BackgroundColors?.DashboardNotificationBorder;
    this.button2 = this.brandingDetails?.branding.BackgroundColors?.Button2;
    this.buttonHover = this.brandingDetails?.branding.BackgroundColors?.ButtonHover;
    this.buttonFontColor = this.brandingDetails?.branding.BackgroundColors?.BtnFont;
    this.activateBtn = this.brandingDetails?.branding.BackgroundColors?.ActivateBtn;
    this.EditBtn = this.brandingDetails?.branding.BackgroundColors?.EditBtn;
    this.EditBtnHover = this.brandingDetails?.branding.BackgroundColors?.EditBtnHover;
    this.redBtn = this.brandingDetails?.branding.BackgroundColors?.BtnRed;
    this.blueBtn = this.brandingDetails?.branding.BackgroundColors?.BtnBlue;
    this.greenBtn = this.brandingDetails?.branding.BackgroundColors?.BtnGreen;
    this.confirmDeleteBtnHover = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtnHover;
    this.confirmDeleteBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtn;
    this.confirmCancelBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmCancelBtn;
    this.alternateRowsLight = this.brandingDetails?.branding?.BackgroundColors?.AlternateRowsLight;
    this.alternateRowsDark = this.brandingDetails?.branding?.BackgroundColors?.AlternateRowsDark;
    this.headerBackground = this.brandingDetails?.branding?.BackgroundColors?.Headers;
    this.selectPersonStatus = this.brandingDetails?.branding?.BackgroundColors?.Headers;
    this.disabledHeaderBackground = this.brandingDetails?.branding?.BackgroundColors?.DisabledHeaderBackground;
    this.editButtonBackground = this.brandingDetails?.branding?.BackgroundColors?.EditBtn;
    this.editButtonHoverBackground = this.brandingDetails?.branding?.BackgroundColors?.EditBtnHover;
    this.gridBorderColor = this.brandingDetails?.branding?.BackgroundColors?.GridBorder;
    this.greyLightBg = this.brandingDetails?.branding?.BackgroundColors?.SideBarBackground;
    this.tabBody = this.brandingDetails?.branding?.BackgroundColors?.TabBody;
    this.cardFontColor = this.brandingDetails?.branding?.BackgroundColors?.CardFontColor;
    this.dropdownBorderColor = this.brandingDetails?.branding?.BackgroundColors?.DropdownBorder;
    this.btnLightBlue = this.brandingDetails?.branding?.BackgroundColors?.ResendColor;
    this.questionnaireSubHeader = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireSubHeader;
    this.formChange = this.brandingDetails?.branding?.BackgroundColors?.FormChangePassword;
    this.formBox = this.brandingDetails?.branding?.BackgroundColors?.FormBoxShadow;
    this.headerLogin = this.brandingDetails?.branding?.BackgroundColors?.HeaderLogin;
    this.pwdBtn = this.brandingDetails?.branding?.BackgroundColors?.PwdBtn;
    this.disabledQuestionnaireHeader = this.brandingDetails?.branding?.BackgroundColors?.DisabledQuestionnaireHeader;
    this.subTabBgColor = this.brandingDetails?.branding.BackgroundColors?.CardBg;
    this.cardCancelButton = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireCardCancelButton;
    this.activeAdminTabFontColor = this.brandingDetails?.branding?.BackgroundColors?.ActiveAdminTabFontColor;

    if (this.toastErrorBgColor) {
      document.documentElement.style.setProperty('--toastErrorBgColor', this.toastErrorBgColor);
    }
    if (this.toastSuccessBgColor) {
      document.documentElement.style.setProperty('--toastSuccessBgColor', this.toastSuccessBgColor);
    }
    if (this.formChange) {
      document.documentElement.style.setProperty('--formChange', this.formChange);
    }
    if (this.pwdBtn) {
      document.documentElement.style.setProperty('--pwdBtn', this.pwdBtn);
    }
    if (this.headerLogin) {
      document.documentElement.style.setProperty('--headerLogin', this.headerLogin);
    }
    if (this.formBox) {
      document.documentElement.style.setProperty('--formBox', this.formBox);
    }
    if (this.notification1) {
      document.documentElement.style.setProperty('--notification1', this.notification1);
    }
    if (this.notification2) {
      document.documentElement.style.setProperty('--notification2', this.notification2);
    }
    if (this.dashboardBorder) {
      document.documentElement.style.setProperty('--dashboardBorder', this.dashboardBorder);
    }
    if (this.cancelButton) {
      document.documentElement.style.setProperty('--cancelButton', this.cancelButton);
    }
    if (this.cancelButtonHover) {
      document.documentElement.style.setProperty('--cancelButtonHover', this.cancelButtonHover);
    }
    if (this.button2) {
      document.documentElement.style.setProperty('--button2', this.button2);
    }
    if (this.buttonHover) {
      document.documentElement.style.setProperty('--buttonHover', this.buttonHover);
    }
    if (this.activateBtn) {
      document.documentElement.style.setProperty('--activateBtn', this.activateBtn);
    }
    if (this.buttonFontColor) {
      document.documentElement.style.setProperty('--buttonFontColor', this.buttonFontColor);
    }
    if (this.EditBtn) {
      document.documentElement.style.setProperty('--EditBtn', this.EditBtn);
    }
    if (this.EditBtnHover) {
      document.documentElement.style.setProperty('--EditBtnHover', this.EditBtnHover);
    }
    if (this.alternateRowsLight) {
      document.documentElement.style.setProperty('--alternateRowsLight', this.alternateRowsLight);
    }
    if (this.alternateRowsDark) {
      document.documentElement.style.setProperty('--alternateRowsDark', this.alternateRowsDark);
    }
    if (this.headerBackground) {
      document.documentElement.style.setProperty('--headerBackground', this.headerBackground);
    }
    if (this.selectPersonStatus) {
      document.documentElement.style.setProperty('--selectPersonStatus', this.headerBackground);
    }
    if (this.disabledHeaderBackground) {
      document.documentElement.style.setProperty('--disabledHeaderBackground', this.disabledHeaderBackground);
    }
    if (this.editButtonBackground) {
      document.documentElement.style.setProperty('--editButtonBackground', this.editButtonBackground);
    }
    if (this.editButtonHoverBackground) {
      document.documentElement.style.setProperty('--editButtonHoverBackground', this.editButtonHoverBackground);
    }
    if (this.confirmDeleteBtnHover) {
      document.documentElement.style.setProperty('--confirmDeleteBtnHover', this.confirmDeleteBtnHover);
    }
    if (this.confirmDeleteBtn) {
      document.documentElement.style.setProperty('--confirmDeleteBtn', this.confirmDeleteBtn);
    }
    if (this.confirmCancelBtn) {
      document.documentElement.style.setProperty('--confirmCancelBtn', this.confirmCancelBtn);
    }
    if (this.gridBorderColor) {
      document.documentElement.style.setProperty('--gridBorderColor', this.gridBorderColor);
    }
    if (this.redBtn) {
      document.documentElement.style.setProperty('--redBtn', this.redBtn);
    }
    if (this.blueBtn) {
      document.documentElement.style.setProperty('--blueBtn', this.blueBtn);
    }
    if (this.greenBtn) {
      document.documentElement.style.setProperty('--greenBtn', this.greenBtn);
    }
    if (this.greyLightBg) {
      document.documentElement.style.setProperty('--greyLightBg', this.greyLightBg);
    }
    if (this.tabBody) {
      document.documentElement.style.setProperty('--tabBody', this.tabBody);
    }
    if (this.cardFontColor) {
      document.documentElement.style.setProperty('--cardFontColor', this.cardFontColor);
    }
    if (this.dropdownBorderColor) {
      document.documentElement.style.setProperty('--dropdownBorderColor', this.dropdownBorderColor);
    }
    if (this.btnLightBlue) {
      document.documentElement.style.setProperty('--resendBtnColor', this.btnLightBlue);
    }
    if (this.questionnaireSubHeader) {
      document.documentElement.style.setProperty('--questionnaireSubHeader', this.questionnaireSubHeader);
    }
    if (this.disabledQuestionnaireHeader) {
      document?.documentElement?.style?.setProperty('--disabledQuestionnaireHeader', this.disabledQuestionnaireHeader);
    }
    if (this.subTabBgColor) {
      document?.documentElement?.style?.setProperty('--subTabBgColor', this.subTabBgColor);
    }
    if (this.cardCancelButton) {
      document?.documentElement?.style?.setProperty('--cardCancelButton', this.cardCancelButton);
    }
    if (this.activeAdminTabFontColor) {
      document.documentElement.style.setProperty('--activeAdminTabFontColor', this.activeAdminTabFontColor);
    }
  }

  setFontColors() {
    this.toastErrorFontColor = this.brandingDetails?.branding?.AlertColors?.ErrorAlertFontColor;
    this.toastSuccessFontColor = this.brandingDetails?.branding?.AlertColors?.SuccessAlertFontColor;
    this.buttonFont = this.brandingDetails?.branding.BackgroundColors?.BtnFont;
    this.tableHeadColor = this.brandingDetails?.branding?.BackgroundColors?.TableHeadColor;
    this.headerFontColor = this.brandingDetails?.branding?.BackgroundColors?.HeaderFontColor;
    this.tableFontColor = this.brandingDetails?.branding?.BackgroundColors?.TableFontColor;
    this.breadcrumbBg = this.brandingDetails?.branding?.BackgroundColors?.SidebarHoverBackground;
    this.linkButtons = this.brandingDetails?.branding.BackgroundColors?.LinkButtons;
    this.activeTabColor = this.brandingDetails?.branding?.BackgroundColors?.BlackHeaderFont;
    if (this.toastErrorFontColor) {
      document.documentElement.style.setProperty('--toastErrorFontColor', this.toastErrorFontColor);
    }
    if (this.toastSuccessFontColor) {
      document.documentElement.style.setProperty('--toastSuccessFontColor', this.toastSuccessFontColor);
    }
    if (this.buttonFont) {
      document.documentElement.style.setProperty('--buttonFont', this.buttonFont);
    }
    if (this.tableHeadColor) {
      document.documentElement.style.setProperty('--tableHeadColor', this.tableHeadColor);
    }
    if (this.headerFontColor) {
      document.documentElement.style.setProperty('--headerFontColor', this.headerFontColor);
    }
    if (this.tableFontColor) {
      document.documentElement.style.setProperty('--tableFontColor', this.tableFontColor);
    }
    if (this.breadcrumbBg) {
      document.documentElement.style.setProperty('--breadcrumbBg', this.breadcrumbBg);
    }
    if (this.linkButtons) {
      document.documentElement.style.setProperty('--linkButtons', this.linkButtons);
    }
    if (this.activeTabColor) {
      document.documentElement.style.setProperty('--activeTabColor', this.activeTabColor);
    }
  }

  setMatColors() {
    this.matTealDark = this.brandingDetails?.branding?.MatColors?.MatTealDark;
    this.matBlack = this.brandingDetails?.branding?.MatColors?.MatBlack;
    this.matWhite = this.brandingDetails?.branding?.MatColors?.MatWhite;
    this.matOrange = this.brandingDetails?.branding?.MatColors?.MatOrange;
    this.matGreenYellow = this.brandingDetails?.branding?.MatColors?.MatGreenYellow;
    this.matGreyGreen = this.brandingDetails?.branding?.MatColors?.MatGreyGreen;
    this.matLightGreen = this.brandingDetails?.branding?.MatColors?.MatLightGreen;
    this.matRussianBlack = this.brandingDetails?.branding?.MatColors?.MatRussianBlack;
    this.matInputGrey = this.brandingDetails?.branding?.MatColors?.MatInputGrey;
    this.matCheckBoxBg = this.brandingDetails?.branding?.MatColors?.MatCheckBoxBg;
    this.checkedCheckBoxBg = this.brandingDetails?.branding?.MatColors?.CheckedCheckBoxBg;
    this.matTealLight = this.brandingDetails?.branding?.MatColors?.MatTealLight;
    this.calenderNotSelectedBg = this.brandingDetails?.branding?.MatColors?.CalenderNotSelectedBg;
    this.datePickerContent = this.brandingDetails?.branding?.MatColors?.DatePickerContent;
    this.checkBoxDisabledBg = this.brandingDetails?.branding?.MatColors?.CheckBoxDisabledBg;
    this.matError = this.brandingDetails?.branding.BackgroundColors?.ErrorFontColor;

    if (this.matTealDark) {
      document.documentElement.style.setProperty('--matTealDark', this.matTealDark);
    }
    if (this.matWhite) {
      document.documentElement.style.setProperty('--matWhite', this.matWhite);
    }
    if (this.matOrange) {
      document.documentElement.style.setProperty('--matOrange', this.matOrange);
    }
    if (this.matGreenYellow) {
      document.documentElement.style.setProperty('--matGreenYellow', this.matGreenYellow);
    }
    if (this.matGreyGreen) {
      document.documentElement.style.setProperty('--matGreyGreen', this.matGreyGreen);
    }
    if (this.matLightGreen) {
      document.documentElement.style.setProperty('--matLightGreen', this.matLightGreen);
    }
    if (this.matRussianBlack) {
      document.documentElement.style.setProperty('--matRussianBlack', this.matRussianBlack);
    }
    if (this.matInputGrey) {
      document.documentElement.style.setProperty('--matInputGrey', this.matInputGrey);
    }
    if (this.matCheckBoxBg) {
      document.documentElement.style.setProperty('--matCheckBoxBg', this.matCheckBoxBg);
    }
    if (this.checkedCheckBoxBg) {
      document.documentElement.style.setProperty('--checkedCheckBoxBg', this.checkedCheckBoxBg);
    }
    if (this.matTealLight) {
      document.documentElement.style.setProperty('--matTealLight', this.matTealLight);
    }
    if (this.calenderNotSelectedBg) {
      document.documentElement.style.setProperty('--calenderNotSelectedBg', this.calenderNotSelectedBg);
    }
    if (this.datePickerContent) {
      document.documentElement.style.setProperty('--datePickerContent', this.datePickerContent);
    }
    if (this.checkBoxDisabledBg) {
      document.documentElement.style.setProperty('--matError', this.checkBoxDisabledBg);
    }
    if (this.matError) {
      document.documentElement.style.setProperty('--matError', this.matError);
    }
    if (this.matError) {
      document.documentElement.style.setProperty('--matError', this.matError);
    }
    if (this.matError) {
      document.documentElement.style.setProperty('--matError', this.matError);
    }
    if (this.matBlack) {
      document.documentElement.style.setProperty('--matBlack', this.matBlack);
    }
  }

  /**
   * Function to close modal
   */
  hide() {
    this.modalRef.hide();
    this.localStorageService.saveInLocalStorage(localStorageVariables.setDefaultAgency, 'true');
  }

  setDefault(agency, type) {
    this.isDefault = false;
    let agencyID = this.localStorageService.getDataFromLocalStorage(localStorageVariables.defaultAgency);
    let newAgency = (type == 'onchange') ? agency?.value : agency;
    if (newAgency.toString() == agencyID.toString()) {
      this.isDefault = true;
    }
  }

  /**
   * Resolve the display name for the currently selected agency from the full
   * (unfiltered) list. Used by <mat-select-trigger> so the trigger text stays
   * correct even after the search filter has removed the selected option from
   * the rendered `agencies` array.
   */
  getSelectedAgencyName(): string {
    if (this.selectedAgency == null) { return ''; }
    const match = (this.originalAgencies || []).find(a => a.agencyID === this.selectedAgency);
    return match ? match.name : '';
  }
}
